























import { defineComponent, toRefs } from '@vue/composition-api';
import TooltipInfo from '@/components/common/tooltip-info/index.vue';
import { useTrackParams } from '../hooks';

const name = 'ttam-ad-text-smart';
export default defineComponent({
  name,
  components: {
    TooltipInfo,
  },
  props: {
    isDisabledCreative: {
      type: Boolean,
      default: false,
    },
    createMode: {
      type: String,
      default: 'create',
    },
  },
  setup(props, { emit }) {
    const { createMode } = toRefs(props);
    const handleClick = () => {
      emit('click');
    };

    const { etSmartTextEntryCode } = useTrackParams({
      createMode,
    });

    return {
      name,
      etSmartTextEntryCode,
      handleClick,
    };
  },
});
